const analytics = {
    payLoad: {
      PLATFORM: 'platform',
      M_CODE: 'm_code',
      KEY_MESSAGE: "message",
      KEY_CLICK: "click",
      KEY_PUSH_NOTIFICATION_ID: "push_notification_id",
      LOCATION: "location",
      ERROR_REASON: "error_reason",
      ERROR_CODE: "error_code",
      REASON: "reason",
      CONSENT_STATUS: "consent_status",
      VERIFY_TYPE: "verify_type",
      APPLICATION_STATUS: "application_status",
      AMOUNT: "amount",
      ACCOUNT_TYPE: "acc_type",
      MODE: "mode",
      CREDIT_LIMIT: "credit_limit",
      INVALID: "invalid",
      RESPONSE: "response",
      SUB_STATUS: "sub_status",
      JSON_PAYLOAD: "json_payload",
      LANDING: "landing",
      URL: "url",
    },
    events: {
      SELECT_SUPPLIER: "select_supplier",
      ENTER_PAYMENT_AMOUNT: "enter_payment_amount",
      AUTHORIZE_PAYMENT: "authorize_payment",
      PAYMENT_PROCESSED: 'payment_processed',
      MANDATE_FAILED: 'mandate_failed',
      G_PAY_MICRO_APP_REDIRECTION_INITIATED: "gpay_microapp_redirection_initiated",
      G_PAY_MICRO_APP_REDIRECTION_STARTED: "gpay_microapp_redirection_Started",
      G_PAY_MICRO_APP_REDIRECTED_URL_PARAMS: "gpay_microapp_redirected_url_params",
      G_PAY_MICRO_APP_REDIRECTED_STARTED_REQUEST_PERMISSIONS: "gpay_microapp_redirected_started_request_permissions",
      G_PAY_MICRO_APP_REDIRECTED_STARTED_REQUEST_PERMISSIONS_RETRY: "gpay_microapp_redirected_started_request_permissions_retry",
      G_PAY_MICRO_APP_LANDING_DETAILS: "gpay_microapp_landing_details",
      G_PAY_MICRO_APP_START_REFERRAL_HIT_API: "gpay_microapp_start_referral_hit_api",
      G_PAY_MICRO_APP_START_REFERRAL_USER_ID_HIT: "gpay_microapp_start_referral_user_id_hit",
      G_PAY_MICRO_APP_REFERRAL_API_SUCCESS: "gpay_microapp_referral_api_success",
      G_PAY_MICRO_APP_REFERRAL_API_FAILED: "gpay_microapp_referral_api_failed",
      G_PAY_MICRO_APP_INITIATED_CHECKED: "gpay_microapp_initiated_checked",
      G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_INITIATED: "gpay_microapp_redirected_request_permissions_initiated",
      G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_PERSONAL_DETAILS_POPUP_DENY: "gpay_microapp_redirected_request_permissions_personal_details_popup_deny",
      G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_PERSONAL_DETAILS_POPUP_RETRY: "gpay_microapp_redirected_request_permissions_personal_details_popup_retry",
      G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_PERSONAL_DETAILS_POPUP_ALLOW: "gpay_microapp_redirected_request_permissions_personal_details_popup_allow",
      G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_LOCATION_POPUP_DENY: "gpay_microapp_redirected_request_permissions_location_popup_deny",
      G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_LOCATION_POPUP_ALLOW: "gpay_microapp_redirected_request_permissions_location_popup_allow",
      G_PAY_MICRO_APP_REFERRAL_START_INITIATED: "gpay_microapp_referral_start_initiated",
      G_PAY_MICRO_APP_REFERRAL_START_API_SUCCESS: "gpay_microapp_referral_start_api_success",
      G_PAY_MICRO_APP_REFERRAL_START_API_FAILURE: "gpay_microapp_referral_start_api_failure",
      G_PAY_MICRO_APP_CREATE_APPLICATION_SUCCESS: "gpay_microapp_create_application_success",
      G_PAY_MICRO_APP_REFERRAL_START_API_NO_TOKEN: "gpay_microapp_referral_start_api_no_token",
      G_PAY_MICRO_APP_CREATE_APPLICATION_FAILURE: "gpay_microapp_create_application_failure",
      G_PAY_MICRO_APP_MARKETPLACE_MAPPING_SUCCESS: "gpay_microapp_marketplace_mapping_success",
      G_PAY_MICRO_APP_MARKETPLACE_MAPPING_FAILURE: "gpay_microapp_marketplace_mapping_failure",
      GPAY_MICRO_APP_MARKETPLACE_DOCUMENT_SUCCESS: "gpay_microapp_marketplace_document_success",
      GPAY_MICRO_APP_MARKETPLACE_DOCUMENT_FAILURE: "gpay_microapp_marketplace_document_failure",
      GPAY_MICRO_APP_VERIFY_OTP_FAILURE: "gpay_microapp_verify_otp_failure",
      GPAY_MICRO_APP_SIGNUP_FAILURE: "gpay_microapp_signup_failure",
      G_PAY_MICRO_APP_CONFIRM_DETAILS: "gpay_microapp_confirm_details",
      G_PAY_MICRO_APP_INVALID_PAN_NUMBER: "gpay_microapp_invalid_pan_number",
      G_PAY_MICRO_APP_RISK_RUN_REJECTED: "gpay_microapp_risk_run_rejected",
      G_PAY_MICRO_APP_KYC_PAGE_LANDED: "gpay_microapp_kyc_page_landed",
      GPAY_MICRO_APP_START_DIGI_KYC_CLICKED: "gpay_microapp_start_digi_kyc_clicked",
      GPAY_MICRO_APP_START_DIGI_KYC_STATUS: "gpay_microapp_start_digi_kyc_status",
      GPAY_MICRO_APP_UPLOAD_MANUALLY_CLICKED: "gpay_microapp_upload_manually_clicked",
      G_PAY_MICRO_APP_INITIAL_CREDIT_OFFER_LANDED: "gpay_microapp_initial_credit_offer_landed",
      G_PAY_MICRO_APP_OFFER_AGREED: "gpay_microapp_offer_agreed",
      GPAY_MICRO_APP_AADHAAR_CLICKED: "gpay_microapp_aadhaar_clicked",
      GPAY_MICRO_APP_PASSPORT_CLICKED: "gpay_microapp_passport_clicked",
      GPAY_MICRO_APP_VOTER_ID_CLICKED: "gpay_microapp_voter_id_clicked",
      GPAY_MICRO_APP_DRIVING_LICENSE_CLICKED: "gpay_microapp_driving_license_clicked",
      GPAY_MICRO_APP_START_DIGI_KYC_URL: "gpay_microapp_start_digi_kyc_url",
      GPAY_MICRO_APP_ADDRESS_PROOF_DOCUMENT_UPLOAD: "gpay_microapp_address_proof_document_upload",
      GPAY_MICRO_APP_REQUEST_MEDIA: "gpay_microapp_request_media",
      GPAY_MICRO_APP_PERSONAL_ADDRESS_LANDED: "gpay_microapp_personal_address_landed",
      GPAY_MICRO_APP_PERSONAL_ADDRESS_CONFIRM_DETAILS_CLICKED: "gpay_microapp_personal_address_confirm_details_clicked",
      GPAY_MICRO_APP_BUSINESS_VERFICATION_LANDED: "gpay_microapp_business_verfication_landed",
      GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API: "gpay_microapp_bank_statement_status_api",
      GPAY_MICRO_APP_BANK_STATEMENT_CLICKED: "gpay_microapp_bank_statement_clicked",
      GPAY_MICRO_APP_MANUAL_BANK_STATEMENT_LIST_LANDED: "gpay_microapp_manual_bank_statement_list_landed",
      GPAY_MICRO_APP_MANUAL_ADD_MORE_BTN_CLICKED: "gpay_microapp_manual_add_more_btn_clicked",
      GPAY_MICRO_APP_MANUAL_BANK_STATEMENT_SUBMIT: "gpay_microapp_manual_bank_statement_submit",
      GPAY_MICRO_APP_MANUAL_REUPLOAD_BTN_CLICKED: "gpay_microapp_manual_reupload_btn_clicked",
      GPAY_MICRO_APP_PASSWORD_PDF_ERROR: "gpay_microapp_password_pdf_error",
      GPAY_MICRO_APP_GLIB_UPLOAD_BANK_STATEMENT: "gpay_microapp_glib_upload_bank_statement",
      GPAY_MICRO_APP_MANUAL_POPUPS: "gpay_microapp_manual_popups",
      GPAY_MICRO_APP_BUSINESS_DOCUMENT_CLICKED: "gpay_microapp_business_document_clicked",
      GPAY_MICRO_APP_BUSINESS_DOCUMENT_MODE_SELECTED: "gpay_microapp_business_document_mode_selected",
      GPAY_MICRO_APP_BUSINESS_REGISTRATION_UPLOAD: "gpay_microapp_business_registration_upload",
      GPAY_MICRO_APP_GSTIN_SUBMIT: "gpay_microapp_gstin_submit",
      GPAY_MICRO_APP_UDYAM_SUBMIT: "gpay_microapp_udyam_submit",
      GPAY_MICRO_APP_VKYC_SLOT_SCHEDULED: "gpay_microapp_vkyc_slot_scheduled",
      GPAY_MICRO_APP_BUSINESS_INFO: "gpay_microapp_business_info",
      GPAY_MICRO_APP_SLOT_BOOK: "gpay_microapp_slot_book",
      GPAY_MICRO_APP_PRODUCT_OFFERS_LANDING: "gpay_microapp_product_offers_landing",
      GPAY_MICRO_APP_RISK_RUN_REJECTED: "gpay_microapp_risk_run_rejected",
      GPAY_MICRO_APP_RISK_RUN_SUCCESSFULL: "gpay_microapp_risk_run_successful",
      GPAY_MICRO_APP_OFFER_CLICKED: "gpay_microapp_offer_clicked",
      GPAY_MICRO_APP_PRODUCT_NEXT_BUTTON_CLICKED: "gpay_microapp_product_next_button_clicked",
      GPAY_MICRO_APP_SELECT_NBFC_API: "gpay_microapp_select_nbfc_api",
      GPAY_MICRO_APP_LOAN_DOCUMENT_LANDED: "gpay_microapp_loan_document_landed",
      GPAY_MICRO_APP_LOAN_SIGN_METHOD_API: "gpay_microapp_loan_sign_method_api",
      GPAY_MICRO_APP_LOAN_DOCUMENT_PROCESSED: "gpay_microapp_loan_document_processed",
      GPAY_MICRO_APP_LOAN_DOCUMENT_CONTINUE_BUTTON_CLICKED: "gpay_microapp_loan_document_continue_button_clicked",
      GPAY_MICRO_APP_LOAN_DOCUMENT_SUBMIT_API: "gpay_microapp_loan_document_submit_api",
      GPAY_MICRO_APP_MANDATE_LANDING: "gpay_microapp_mandate_landing",
      GPAY_MICRO_APP_MANDATE_ACCOUNT_TYPE: "gpay_micro_app_mandate_account_type",
      GPAY_MICRO_APP_MANDATE_AVAILABILITY: "gpay_micro_app_mandate_availability",
      GPAY_MICRO_APP_MANDATE_MODES: "gpay_micro_app_mandate_modes",
      GPAY_MICRO_APP_BANK_INFO: "gpay_micro_app_bank_info",
      GPAY_MICRO_APP_MANDATE_STATUS: "gpay_micro_app_mandate_status",
      GPAY_MICRO_APP_NACH_MANDATE: "gpay_micro_app_nach_mandate",
      GPAY_MICRO_APP_DETAILS: "gpay_micro_app_details",
      GPAY_MICRO_APP_JOURNEY_COMPLETION: "gpay_micro_app_journey_completion",
      GPAY_MICRO_APP_THIRD_PARTY_TAB_SWITCH: "gpay_micro_app_third_party_tab_switch",
      G_PAY_MICRO_APP_FETCH_DETAILS_API: "g_pay_micro_app_fetch_details_api",
      G_PAY_MICRO_APP_SUMMARY_API: "g_pay_micro_app_summary_api",
      G_PAY_MICRO_APP_PAN_TO_GST_API: "g_pay_micro_app_pan_to_gst_api",
      G_PAY_MICRO_APP_SHORT_REFERRAL_API: "g_pay_micro_app_short_referral_api",
      GPAY_MICRO_APP_CURRENT_ADDRESS_API: "gpay_micro_app_current_address_api",
      GPAY_MICRO_APP_COMMUNCATION_ADDRESS_DOCUMENT_UPLOAD: "gpay_micro_app_communcation_address_document_upload",
      GPAY_MICRO_APP_BANK_STATEMENT_MODE: "gpay_micro_app_bank_statement_mode",
      GPAY_MICRO_APP_CONSENT_API: "gpay_micro_app_consent_api",
      G_PAY_MICRO_APP_CREATE_APPLICATION_METHOD_IN: 'gpay_micro_app_create_application_method_in',
      G_PAY_MICRO_APP_CREATE_APPLICATION_METHOD_COUNT: 'gpay_micro_app_create_application_method_count',
      GPAY_MICRO_APP_VKYC_CLICKED: "gpay_micro_app_vkyc_clicked",
      GPAY_MICRO_APP_SUPPORT_CLICKED: "gpay_micro_app_support_clicked",
      GPAY_MICRO_APP_LOAN_DOCUMENT_SIGN_SUBMIT_BUTTON_CLICKED: "gpay_micro_app_loan_document_sign_submit_button_clicked",
      GPAY_MICRO_APP_FLOW_MODULE_ONBOARDING_API: "gpay_micro_app_flow_module_onboarding_api",
      GPY_MICRO_APP_ONBOARDING_SIGN_API: "gpy_micro_app_onboarding_sign_api",
      GPAY_MICRO_APP_CUSTOMER_LANGUAGE_API: "gpay_micro_app_customer_language_api",
      GPAY_MICRO_APP_INIT_PAYTM_API: "gpay_micro_app_init_paytm_api",
    },
  };
  const methods = {
    registerProperties(event) {
      this.$mixpanel.register(event);
    },
    // registerProperties(mixpanel) {
    //   mixpanel.register({
    //     platform: 'web',
    //     m_code: 'gpay',
    //   });
    // },
    trackUuid(uuid) {
      this.$mixpanel.identify(uuid);
    },
    trackEvent(event, payload) {
      this.$mixpanel.track(event, payload);
    },
  };

  export default { analytics, methods };
